import {navRootLoader} from '@rankers/online_apps/nav/components/nav_root/nav_root_loader';
navRootLoader();

import {suppressNativeLongPressMenus} from '@rankers/lib/long_press_menu_suppressor';
suppressNativeLongPressMenus();

import {enableInstantActiveStates} from '@rankers/lib/instant_active_states';
enableInstantActiveStates();

// These following components are used within the nav HTML.
// These are components that are not integral to the nav, but are used within the nav.
// Components that *are* integral to the nav should be loaded via the `NavRoot` component above.

import {paneSlidesLoader} from '@rankers/components/pane_slides/pane_slides_loader';
paneSlidesLoader();

import {breakpointerLoader} from '@rankers/components/breakpointer/breakpointer_loader';
breakpointerLoader();

import {analyticsWatcherLoader} from '@rankers/components/analytics_watcher/analytics_watcher_loader';
analyticsWatcherLoader();

import { starRatingLoader } from '@rankers/components/star_rating/star_rating_loader';
starRatingLoader();



